routes.$inject = ['$routeProvider'];

export default function routes($routeProvider) {
  $routeProvider
    .when('/help', {
      redirectTo: function () {
        // redirect to help (server page)
        window.location.href = "/help"
      }
    });
}



// WEBPACK FOOTER //
// ./project/pages/help/help.routes.js